import React, { useState, useEffect, Component } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

const LeaseMoveInOut = () => {
    const apiService = new LeaseApiService();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [unitClass, setUnitClass] = useState([]);

    const [formData, setFormData] = useState({
        property: "",
        from: "",
        movein: "Move In",
        unitNo: "",
        to: "",
        unitClass: "",
    })

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        fetchDropdownData()
        const today = new Date();
        let todate = formatDate(today)
        setFormData((prev) => ({ ...prev, to: todate, from: todate }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRNaSearchUnitClass');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties)
            setUnitClass(res?.data?.dropdowns?.LRNaSearchUnitClass)

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("moveInOutRequest.FromDate", formData?.from || todate);
            params.append("moveInOutRequest.ToDate", formData?.to || todate);
            params.append("moveInOutRequest.PropertyNo", formData?.property?.value?.value || "All");
            params.append("moveInOutRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("moveInOutRequest.UnitClass", formData?.unitClass?.label || "All");
            params.append("moveInOutRequest.MoveIn", formData?.movein === "Move In" ? true : false);
            params.append("moveInOutRequest.MoveOut", formData?.movein === "Move Out" ? true : false);
            params.append("moveInOutRequest.FlatShifting", formData?.movein === "Flat Shifting" ? true : false);
            const res = await apiService.getApiParamater("REPORT_LEASE_MOVE_IN_OUT", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
                setLoader(false)
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("moveInOutRequest.FromDate", formData?.from || todate);
            params.append("moveInOutRequest.ToDate", formData?.to || todate);
            params.append("moveInOutRequest.PropertyNo", formData?.property?.value?.value || "All");
            params.append("moveInOutRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("moveInOutRequest.UnitClass", formData?.unitClass?.label || "All");
            params.append("moveInOutRequest.MoveIn", formData?.movein === "Move In" ? true : false);
            params.append("moveInOutRequest.MoveOut", formData?.movein === "Move Out" ? true : false);
            params.append("moveInOutRequest.FlatShifting", formData?.movein === "Flat Shifting" ? true : false);
            const res = await apiService.getApiParamater("REPORT_LEASE_MOVE_IN_OUT", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setExportData(result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2)
            ? 0
            : momentDate1.isBefore(momentDate2)
                ? -1
                : 1;
    }
    const columnDefs = [
        { headerName: "Property Name", field: "propertyName", filter: true, floatingFilter: true, suppressMovable: true, width: 200, pinned: "left", },
        { headerName: "Unit No", field: "unitNo", filter: true, floatingFilter: true, suppressMovable: true, width: 120, pinned: "left", },
        { headerName: "Tanent Name", field: "tenantName", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Agent/Direct", field: "agentDirect", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Contract Type", field: "contractType", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Contract Period", field: "contractPeriod", filter: true, floatingfilter: true, suppressMovable: true, width: 180, },
        { headerName: "Unit CLass", field: "unitClass", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Remarks", field: "remarks", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Type", field: "type", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Actual Start Date", field: "actualStartDate", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "Lease Date", field: "leaseDate", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "Vacating Date", field: "vacatingDate", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "Finished/ Pre Terminated", field: "finishedPreTerminated", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
    ]
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setUnitList([])
        setFormData({
            property: "",
            movein: "Move In",
            unitNo: "",
            from: todate,
            to: todate,
            unitClass: "",
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', value?.value?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items)
        }
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return ""; // keep this if you want 0 to be empty

        // Check if value is a date string in ISO format
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        const columns = [
            { header: "Property Name", dataKey: "propertyName", width: 100 },
            { header: "Unit No", dataKey: "unitNo", width: 50 },
            { header: "Agent/Direct", dataKey: "agentDirect", width: 100 },
            { header: "Contract Type", dataKey: "contractType", width: 50 },
            { header: "Contract Period", dataKey: "contractPeriod", width: 60 },
            { header: "Unit CLass", dataKey: "unitClass", width: 60 },
            { header: "Remarks", dataKey: "remarks", width: 50 },
            { header: "Type", dataKey: "type", width: 50 },
            { header: "Actual Start Date", dataKey: "actualStartDate", width: 50 },
            { header: "Lease Date", dataKey: "leaseDate", width: 80 },
            { header: "Vacating Date", dataKey: "vacatingDate", width: 60 },
            { header: "Finished/ Pre Terminated", dataKey: "finishedPreTerminated", width: 60 },
        ];

        /* ========= HEADER ========= */

        doc.setFillColor(110, 81, 153); // #6E5199
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Move In/Out Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated unit: ${moment(formData?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        /* ========= TABLE ========= */
        doc.autoTable({
            startY: 60,
            head: [columns.map(col => col.header)],
            body: exportData.map(row =>
                columns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Move_in_out_Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const columns = [
            { header: "Property Name", dataKey: "propertyName", width: 100 },
            { header: "Unit No", dataKey: "unitNo", width: 50 },
            { header: "Agent/Direct", dataKey: "agentDirect", width: 100 },
            { header: "Contract Type", dataKey: "contractType", width: 50 },
            { header: "Contract Period", dataKey: "contractPeriod", width: 60 },
            { header: "Unit CLass", dataKey: "unitClass", width: 60 },
            { header: "Remarks", dataKey: "remarks", width: 50 },
            { header: "Type", dataKey: "type", width: 50 },
            { header: "Actual Start Date", dataKey: "actualStartDate", width: 50 },
            { header: "Lease Date", dataKey: "leaseDate", width: 80 },
            { header: "Vacating Date", dataKey: "vacatingDate", width: 60 },
            { header: "Finished/ Pre Terminated", dataKey: "finishedPreTerminated", width: 60 },
        ];

        const excelData = exportData.map(item => {
            const row = {};
            columns.forEach(col => {
                row[col.header] = normalizeValue(item[col.dataKey]);
            });
            return row;
        });
        
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Move In Out Report");
        XLSX.writeFile(workbook, "Move_in_out_Report.xlsx");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">From</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex gap-3">
                                {["Move In", "Move Out", "Flat Shifting"].map((label) => (
                                    <div className="form-check" key={label}>
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            name="term"
                                            value={label}
                                            checked={formData.movein === label}
                                            onChange={(e) => setFormData(prev => ({ ...prev, movein: label }))}
                                        />
                                        <label className="form-check-label">{label}</label>
                                    </div>
                                ))}
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit No</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label w-0">To</label>
                                <DatePicker
                                    selected={formData.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-50">
                                        <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit Class</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitClass}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitClass', value: selectedOption })}
                                    options={unitClass?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Move IN Out List</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>
                        <div className="gridshad  mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: "#F0EDF5" };
                                        } else {
                                            return { background: "#fff" };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default LeaseMoveInOut;
